import { List, Map } from 'immutable';
import { dispatch } from 'nike-re-framejs';

function openUpdater(popupName, popupData, priority = 1) {
    return db =>
        db.updateIn(['gui', 'popup/ng'], List(), list => {
            let newList = list;
            const entry = Map({ name: popupName, data: popupData, priority });
            if (list.indexOf(entry) === -1) {
                newList = newList.push(entry);
            }
            return newList.sortBy(e => -e.get('priority'));
        });
}

function onClose(conf) {
    const data = conf && conf.get('data');
    if (data && data.onClose) data.onClose();
}

function closeUpdater(name) {
    return db =>
        db.updateIn(['gui', 'popup/ng'], List(), list => {
            const idx = name ? list.findIndex(obj => obj.get('name') === name) : 0;
            if (idx === -1) return list;
            onClose(list.get(idx));
            return list.delete(idx);
        });
}

function closeAllUpdater() {
    return db =>
        db.updateIn(['gui', 'popup/ng'], List(), list => {
            list.forEach(c => {
                onClose(c);
            });
            return list.clear();
        });
}

function dispatchOpen(popupName, popupData, priority = 1) {
    dispatch(['ui.popup/ng', popupName, popupData, priority]);
}

function dispatchClose(name) {
    dispatch(['ui.popup/ng-close', typeof name === 'string' ? name : null]);
}

function dispatchCloseAll() {
    dispatch(['ui.popup/ng-close-all', null]);
}

const dispatcher = {
    open: dispatchOpen,
    close: dispatchClose,
    closeAll: dispatchCloseAll
};

const updater = {
    open: openUpdater,
    close: closeUpdater,
    closeAll: closeAllUpdater
};

const PopupNg = { updater, dispatcher };

export default PopupNg;
